import { render } from "./drop-down-menu.vue?vue&type=template&id=65587e3b"
import script from "./drop-down-menu.vue?vue&type=script&lang=js"
export * from "./drop-down-menu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__